// extracted by mini-css-extract-plugin
export default {"container":"Home_container__QFrZE","content":"Home_content__XKdGs","btn":"Home_btn__d26XQ"};